/**
 * The Quality report's sections. On a scoring job the Job page shows each as its own
 * tab (the scores ARE the job); on any other job they sit inside the Quality tab.
 */
export const QUALITY_SECTIONS = ['overview', 'products', 'rules', 'fields'] as const;
export type QualitySection = (typeof QUALITY_SECTIONS)[number];
